import { GlDisclosureDropdown, GlButton, GlTooltip } from '@gitlab/ui';
import { uniqueId } from 'lodash-es';
import { __, sprintf } from '~/locale';
import { clamp } from '../services/utils';
export const tableContentType = 'table';
const MIN_ROWS = 5;
const MIN_COLS = 5;
const MAX_ROWS = 10;
const MAX_COLS = 10;
export default {
    name: 'ToolbarTableButton',
    components: {
        GlButton,
        GlDisclosureDropdown,
        GlTooltip
    },
    emits: [
        'execute',
        'insert-table'
    ],
    data () {
        return {
            toggleId: uniqueId('dropdown-toggle-btn-'),
            maxRows: MIN_ROWS,
            maxCols: MIN_COLS,
            rows: 1,
            cols: 1
        };
    },
    methods: {
        list (n) {
            return new Array(n).fill().map((_, i)=>i + 1);
        },
        setRowsAndCols (rows, cols) {
            this.rows = rows;
            this.cols = cols;
            this.maxRows = clamp(rows + 1, this.maxRows, MAX_ROWS);
            this.maxCols = clamp(cols + 1, this.maxCols, MAX_COLS);
        },
        resetState () {
            this.rows = 1;
            this.cols = 1;
            this.maxRows = MIN_ROWS;
            this.maxCols = MIN_COLS;
        },
        insertTable () {
            this.$emit('insert-table', {
                rows: this.rows,
                cols: this.cols
            });
            this.resetState();
            this.$refs.dropdown.close();
            this.$emit('execute', {
                contentType: 'table'
            });
        },
        getButtonLabel (rows, cols) {
            return sprintf(__('Insert a %{rows}×%{cols} table'), {
                rows,
                cols
            });
        },
        onKeydown (key) {
            const delta = {
                ArrowUp: {
                    rows: -1,
                    cols: 0
                },
                ArrowDown: {
                    rows: 1,
                    cols: 0
                },
                ArrowLeft: {
                    rows: 0,
                    cols: -1
                },
                ArrowRight: {
                    rows: 0,
                    cols: 1
                }
            }[key] || {
                rows: 0,
                cols: 0
            };
            const rows = clamp(this.rows + delta.rows, 1, this.maxRows);
            const cols = clamp(this.cols + delta.cols, 1, this.maxCols);
            this.setRowsAndCols(rows, cols);
        },
        setFocus (row, col) {
            this.resetState();
            this.$refs[`table-${row}-${col}`][0].$el.focus();
        }
    },
    MAX_COLS,
    MAX_ROWS
};
